import * as E from 'fp-ts/Either';
import { config } from '../config';
import {
  insertItem,
  updateItem,
  page as commonPage,
  removeItem,
} from './common';

export type User = {
  _id: string;
  username: string;
  roles: string[];
  updatedAt: string;
  createdAt: string;
  deletedAt: string;
};

export const single = async (token: string, userId: string) => {
  const result = await fetch(
    `${config.apiUrl}/cms/v1/users/${encodeURIComponent(userId)}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const body = await result.json();

  return result.status === 200 ? E.right(body) : E.left(body);
};

export const page = commonPage<User>(`${config.apiUrl}/cms/v1/users`);

export const remove = removeItem(`${config.apiUrl}/cms/v1/users`);

export const insert = insertItem<User>(`${config.apiUrl}/cms/v1/users`);

export const update = updateItem<User>(`${config.apiUrl}/cms/v1/users`);
